import { type FC, type ReactNode, useMemo, useState } from "react";
import { LeftMenuContext } from "../contexts/LeftMenuContext";

export const LeftMenuProvider: FC<{ children: ReactNode }> = ({ children }) => {
  const [leftMenuWidth, setLeftMenuWidth] = useState(0);

  const value = useMemo(
    () => ({
      leftMenuWidth,
      setLeftMenuWidth,
    }),
    [leftMenuWidth],
  );

  return (
    <LeftMenuContext.Provider value={value}>
      {children}
    </LeftMenuContext.Provider>
  );
};
